<template>
	<div id="AdditionalInformation">
		<div class="cols-2">
			<div class="box">
				<h2>Upgrade Your Experience</h2>
				<p>There is still time to upgrade your experience.  Please visit the <a :href="ticket_url" title="Visit the Sales Portal" target="_blank">tickets page</a> for more information.</p>
			</div>
			<div class="box" id="Newsletter">
				<form action="https://shambhalamusicfestival.us5.list-manage.com/subscribe/post?u=142d258118083ffd2630e2e25&amp;id=aef4f50da0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
					<h2>Sign up for Newsletter</h2>
					<input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL" />
					<button type="submit" v-bind:disabled="this.newsletter_subscribe"><i class="fab fa-telegram-plane"></i> Subscribe</button>
				</form>
			</div>
		</div>
		<div class="box dark">
			<div class="cols-2">
				<div>
					<img :src="this.cover2" alt="Shambhala Music Festival Ticket FAQs" />
				</div>
				<div class="clear-after">
					<p>Learn how to easily manage your tickets and lodging as well as transfers to friends & family.</p>
					<a href="https://shambhalamusicfestival.com/tickets/#electronicticketingfaq" target="_blank">Read the Tickets FAQ &gt;&gt;</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AdditionalInformation',
		data() {
			return {
				newsletter_subscribe: false,
				ticket_url: window.portal.ticket_url,
				cover2: window.portal.cover2 ? window.portal.cover2 : process.env.VUE_APP_COVER_IMAGE_2
			}
		},
		mounted: function() {
			this.checkSettings();
		},
		methods: { 
			// Check and set settings - this is needed to use the settings from the API call in UserPortal.vue
			checkSettings: function() {
				if (window.portal.ticket_url) {
					this.ticket_url = window.portal.ticket_url;
				}
				if (window.portal.cover2) {
					this.cover2 = window.portal.cover2;
				} else {
					setTimeout(() => {
						this.checkSettings();
					}, 100);
				}
			},
		},
	}
</script>

<style>
	#AdditionalInformation h2 { border-bottom: 0px none; font-size: 1.8em; }
	#AdditionalInformation p { margin: 0; font-size: 14px; }
	#AdditionalInformation .box.dark .cols-2>div:first-child { padding: 10px 50px 10px 10px; }
	#AdditionalInformation .box.dark .cols-2>div:last-child { padding: 10px 20px; }
	#AdditionalInformation .box.dark .cols-2>div:last-child a { display: block; float: right; margin: 15px 0 0 0; }
</style>